<template>
  <div @drop.prevent @dragenter.prevent @dragover.prevent>
    <div
      @drop="dropHandler"
      @dragover="isDroppable = true"
      @dragleave="isDroppable = false"
      :class="{ droppable: isDroppable }"
    >
      <p>{{ $t('PROFILE_PICTURE_DESCRIPTION') }}</p>
      <div class="imgArea">
        <profile-icon size="huge" :user="thisUser" />
      </div>
      <div class="ui buttons">
        <button
          class="ui green labeled icon button capitalize-fl"
          @click.prevent
          @click="uploadImage"
        >
          <i class="upload icon" />
          {{ $t('PROFILE_PICTURE_UPLOAD') }}
        </button>
        <button
          class="ui right labeled icon button capitalize-fl"
          type="button"
          @click="resetImage"
        >
          {{ $t('PROFILE_PICTURE_RESET') }}
          <i class="user circle icon"></i>
        </button>
      </div>
      <input
        type="file"
        id="file"
        ref="file"
        accept="image/*"
        @change="imageUpload"
        style="display: none"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.imgArea {
  margin-bottom: 2em;
}
.droppable {
  opacity: 0.5;
}
</style>

<script>
import ProfileIcon from '../ProfileIcon.vue'
import Toast from '../../../services/Toast.js'

export default {
  name: 'ProfilePicture',
  props: {
    value: {
      type: String
    },
    thisUser: {
      type: Object
    }
  },
  components: { ProfileIcon },
  data() {
    return {
      isDroppable: false
    }
  },

  methods: {
    imageUpload() {
      this.emitImage(this.$refs.file.files[0])
    },
    resetImage() {
      this.$emit('update', (this.value = ''))
    },
    uploadImage() {
      this.$refs.file.click()
    },
    dropHandler(e) {
      this.isDroppable = false
      let file = e.dataTransfer.items[0].getAsFile()
      // tests if the dropped element is an image
      if (file && file['type'].split('/')[0] === 'image') {
        this.emitImage(file)
      } else {
        Toast.error(this.$t('PROFILE_PICTURE_TYPE_ERROR'))
      }
    },
    emitImage(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onloadend = () =>
        file.size <= 100000
          ? this.$emit('update', (this.value = reader.result))
          : Toast.error(this.$t('PROFILE_PICTURE_SIZE_EXCEED'))
    }
  }
}
</script>
